import React, { useContext, useEffect, useRef, useState } from "react";
import '../../../styles/pageStyles/applicationListing/applicationListing.css'
import { useNavigate, NavLink } from "react-router-dom";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import  Alert from "@mui/material/Alert"
import Select from "@mui/material/Select"
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import DebouncedInput from "../../common/DebouncedInput";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import ApplicationListingTable from "./ApplicationListingTable";
import CustomModal from "../../common/modals/CustomModal";
import config from "../../../config/Config";
import Layout from "../../common/Layout";
import { ApplicationStatusContext, FormContext, OriginatorListContext } from "../../../context/FormContext";

import { format, isValid, parse } from "date-fns";
import { useFormik } from "formik";
import { CircularProgress } from "@mui/material";
import CustomDateInput from "../../common/CustomDateInput";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import AdvancedFilterPanel from './AdvanceFilter';
import AIChatbot from "./AIChatBot";
import ChatIcon from '@mui/icons-material/Chat';
import { Fab, Backdrop } from '@mui/material';

const appendInlineTextFilter = (url, filterObj, paramMap) => {
  if (!filterObj) return url;
  let nextUrl = url;
  if (filterObj.contains && paramMap.contains) {
    nextUrl += `&${paramMap.contains}=${filterObj.contains}`;
  }
  if (filterObj.startswith && paramMap.startswith) {
    nextUrl += `&${paramMap.startswith}=${filterObj.startswith}`;
  }
  if (filterObj.endswith && paramMap.endswith) {
    nextUrl += `&${paramMap.endswith}=${filterObj.endswith}`;
  }
  return nextUrl;
};

const appendNumericRangeFilter = (url, filterObj, gteKey, lteKey) => {
  if (!filterObj) return url;
  let nextUrl = url;
  if (filterObj.gte) nextUrl += `&${gteKey}=${filterObj.gte}`;
  if (filterObj.lte) nextUrl += `&${lteKey}=${filterObj.lte}`;
  return nextUrl;
};

var localTemp = [];

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: "14px !important",
  fontFamily:'proxima-regular !important',
  padding: "0px 0px 2px 10px",
  "&:hover": {
    backgroundColor: "#067de2 !important",
    color: "#fff !important",
    "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
      color: "#OOO !important",
      fontSize: "16px !important",
    },
  },
  "&.Mui-selected": {
    backgroundColor: "#ffff !important",
  },
  "&.Mui-selected:hover": {
    color: "#fff !important",
    backgroundColor: "#067de2 !important",
  },
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  color: "#000 !important",
  fontSize: "14px !important",
  width: "175px !important",
  height:'30px !important',
  padding: "4px 4px 4px 10px !important",
  borderRadius: "5px !important",
  border: "0.5px solid #707070 !important",
  fontFamily:'proxima-regular !important',
}));

const CustomButton = styled(Button)(({ theme }) => ({
  margin: '20px 15px 0px 0px',
  borderRadius: '25px' ,
  padding: '10px 15px',
  fontSize: '16px',
  height: '35px',
  textTransform: 'capitalize' ,
  fontFamily: 'proxima-regular !important',
  minWidth: '130px ',
  background:' #067de2 !important',
  color:'#fff !important'
}));

const ITEM_HEIGHT = 100;
const ITEM_PADDING_TOP = 10;
var ITEM_MARGIN_TOP = 0;
if (window.innerWidth <= 320) {
  ITEM_MARGIN_TOP = 210;
} else if (window.innerWidth <= 375) {
  ITEM_MARGIN_TOP = 200;
} else if (window.innerWidth <= 425) {
  ITEM_MARGIN_TOP = 195;
} else if (window.innerWidth <= 768) {
  ITEM_MARGIN_TOP = 115;
} else {
  ITEM_MARGIN_TOP = 0;
}

const MenuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
  getContentAnchorEl: null,
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
      marginTop: ITEM_MARGIN_TOP,
    },
  },
};

const ApplicationListing =()=>{
  const navigate = useNavigate();
  const vertical = 'top';
  const horizontal = 'center';

  //  ---------------------Application Listing States ----------------------------
  const [forms, setForms] = useContext(FormContext);
  const [originatorNames, setOriginatorNames] = useContext(OriginatorListContext)
  const [masterCheck, setMasterCheck] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [cxSpecialistValue, setCxSpecialistValue] = useState("all");
  const [originatorValue, setOriginatorValue] = useState("all");
  const [appStatus, setAppStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteAppModalOpen,setDeleteAppModal]=useState(false);
  const [snakbarMssg,setSnakbarMssg]=useState('')
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severityType, setSeverityType] = useState('');
  const [allStatus, setAllStatus] = useState([]);
  const [exportModalOpen,setExportModalOpen]=useState(false)
  const [isExportLoading,setIsExportLoading]=useState(false)    
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [
    cxSpecialist,
    setCxSpecialist,
    newApplicationStatus,
    setNewApplicationStatus,
    cxSpecialists,
    setCxSpecialists
  ] = useContext(ApplicationStatusContext)
  const startDatePickerRef = useRef(null);
  const endDatePickerRef = useRef(null);

  // --------------------------AI ChatBotState-------------------------------------
  const [chatbotOpen, setChatbotOpen] = useState(false);

  //-----------------Advanced Filter / Inline filter state--------------------------- 
  const [selectedInlineFilters, setSelectedInlineFilters] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({});
  const [inlineFilters, setInlineFilters] = useState({});
  const [states, setStates] = useState([]);
  const [pageSize, setPageSize] = useState(() => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("user_info") || "{}");
      const n = Number(userInfo?.preferences?.application_listing_row_per_page);
      return Number.isFinite(n) && n > 0 ? n : 8;
    } catch {
      return 8;
    }
  });
  const [filtersAppliedOnce, setFiltersAppliedOnce] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pendingInlineFilters, setPendingInlineFilters] = useState({});
  const [filterApplyCount, setFilterApplyCount] = useState(0);
  const PROPERTY_TYPE_OPTIONS = [
        { id: 2, label: "Single Family Residence" },
        { id: 5, label: "Duplex" },
        { id: 4, label: "Townhouse" },
        { id: 3, label: "Condominium" },
        { id: 6, label: "Manufactured Home - Not Supported" }
    ];

// --------------------------- ADVANCED FILTER PANEL STATE --------------------------
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [filters, setFilters] = useState({});
  const [showFilters, setShowFilters] = useState(false);
  const [pendingFilters, setPendingFilters] = useState({});
  const [globalSearch, setGlobalSearch] = useState("");
  const [inputText, setInputText] = useState({});
  const [dateError, setDateError] = useState("");
  const [isEmailExportLoading, setIsEmailExportLoading] = useState(false);

// -----------------  Advanced Filter Helper Functions and Effects----------------
 const updatePendingFilter = (key, value) => {
    setPendingFilters(prev => {
      const currentVal = Array.isArray(prev[key]) ? prev[key] : [];
      const exists = currentVal.includes(value);

      const updated = exists
        ? currentVal.filter(v => v !== value)
        : [...currentVal, value];

      return {
        ...prev,
        // [key]: updated.length ? updated : undefined
        [key]: updated
      };
    });
  };

    const applyFilters = () => {
        const from = pendingFilters.created_date_from;
        const to = pendingFilters.created_date_to;

        setDateError("");

        if (from && !to) return setDateError("Please select the end date.");
        if (!from && to) return setDateError("Please select the start date.");
        if (from && to && new Date(to) < new Date(from))
            return setDateError("The To date cannot be earlier than the From date.");

        const cleaned = {};

        Object.entries(pendingFilters).forEach(([k, v]) => {
            if (v !== "" && v !== null && !(Array.isArray(v) && v.length === 0)) {
                cleaned[k] = v;
            }
        });

        setSelectedFilters(cleaned);
        setFilters(pendingFilters);
        setSelectedInlineFilters(prev => ({ ...prev, ...pendingInlineFilters }));
        setFiltersAppliedOnce(true)
        setFilterApplyCount(prev => prev + 1);
    };

  const clearAllFilters = () => {
    setPendingFilters({});
    setFilters({});
    setGlobalSearch("");
    setInputText({          
        property_types: "",
        cx_specialist: "",
        app_status: "",
        originator: "",
        state: ""
    });
    setDateError(null);
    setSelectedFilters({});
    setPendingInlineFilters({});      
  };

   // Sync advanced filters → local filter dropdowns
  useEffect(() => {
    applyAdvancedFilters();
  }, [filters]);

  // Debounced global search from AdvancedFilterPanel
  useEffect(() => {
    const timeout = setTimeout(() => {
      setSearchTerm(globalSearch);
      setCurrentPage(1);
      setFiltersApplied(true);
    }, 400);
    return () => clearTimeout(timeout);
  }, [globalSearch]);

  //Fetch states for filter labels
  useEffect(() => {
    let token = localStorage.getItem("access_token");
    fetch(`${config.baseUrl}get-states/`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setStates(data))
      .catch(err => console.log(err));
  }, [])

  //buildAdvancedFilterUrl (used by both table and export)
  const buildAdvancedFilterUrl = (baseUrl, advancedFilters, inlineFilters,searchTerm) => {
    let url = baseUrl;
    const filters = inlineFilters || {};

    if (searchTerm && searchTerm.trim() !== "") {
      url += `&search=${encodeURIComponent(searchTerm.trim())}`;
    }

    //Advanced Filters 
    if (advancedFilters) {
      if (advancedFilters.cx_specialist)
        url += `&cx_specialists=${advancedFilters.cx_specialist.join(",")}`;

      if (advancedFilters.app_status)
        url += `&statuses=${advancedFilters.app_status.join(",")}`;

      if (advancedFilters.originator)
        url += `&originators=${advancedFilters.originator.join(",")}`;

      if (advancedFilters.property_types)
        url += `&property_types=${advancedFilters.property_types.join(",")}`;

      if (advancedFilters.state)
        url += `&states=${advancedFilters.state.join(",")}`;

      // Inline column filters
      if (filters.originator_name) {
        const f = filters.originator_name;
        if (f.contains) url += `&originator_name_contains=${f.contains}`;
        if (f.startswith) url += `&originator_name_startswith=${f.startswith}`;
        if (f.endswith) url += `&originator_name_endswith=${f.endswith}`;
      }

      if (filters.borrower_name) {
        const f = filters.borrower_name;
        if (f.contains) url += `&borrower_name__icontains=${f.contains}`;
        if (f.startswith) url += `&borrower_name_startswith=${f.startswith}`;
        if (f.endswith) url += `&borrower_name_endswith=${f.endswith}`;
      }

      if (filters.property_address) {
        const f = filters.property_address;
        if (f.contains) url += `&address__icontains=${f.contains}`;
        if (f.startswith) url += `&address__istartswith=${f.startswith}`;
        if (f.zip_code) url += `&zip_code=${f.zip_code}`;
      }

      if (filters.cx_specialist_name) {
        const f = filters.cx_specialist_name;
        if (f.contains) url += `&cx_name__icontains=${f.contains}`;
        if (f.startswith) url += `&cx_name_startswith=${f.startswith}`;
        if (f.endswith) url += `&cx_name_endswith=${f.endswith}`;
      }

      if (filters.application_status_name) {
        const f = filters.application_status_name;
        if (f.contains) url += `&application_status_contains=${f.contains}`;
        if (f.startswith)
          url += `&application_status_startswith=${f.startswith}`;
        if (f.endswith) url += `&application_status_endswith=${f.endswith}`;
      }

      if (filters.application_number?.contains) {
        url += `&application_number_contains=${filters.application_number.contains}`;
      }

      const BOOLEAN_INLINE_KEYS = [
        "submitted_to_crm",
        "is_test_app",
        "is_submitted_by_partner_api",
        "is_upside_submission",
        "is_upside_interested",
      ];
      BOOLEAN_INLINE_KEYS.forEach((key) => {
        if (filters[key] !== undefined && filters[key]?.value !== undefined) {
          url += `&${key}=${filters[key].value}`;
        }
      });
      if (filters.is_upside_interested !== undefined) {
        const f = filters.is_upside_interested;
        if (f?.value !== undefined) {
          url += `&is_upside_interested=${f.value}`;
        } else if (f?.is_null) {
          url += `&is_upside_interested__isnull=true`;
        }
      }
      
      // Inline created_date range filter { from, to, on }
      if (filters.created_date) {
        const f = filters.created_date;
        if (f.on) {
          url += `&created_date__date=${f.on}`;
        } else if (f.from && f.to) {
          url += `&created_date__range=${f.from},${f.to}T23:59:59`;
        } else if (f.from) {
          url += `&created_date__gte=${f.from}`;
        } else if (f.to) {
          url += `&created_date__lte=${f.to}T23:59:59`;
        }
      }

      // Updated Date
      if (filters.updated_date) {
        const f = filters.updated_date;
        if (f.on) url += `&updated_date__date=${f.on}`;
      }

      url = appendInlineTextFilter(url, filters.property_type, {
        contains: "property_type_contains",
        startswith: "property_type_startswith",
        endswith: "property_type_endswith",
      });

      url = appendInlineTextFilter(url, filters.company_name, {
        contains: "company_name_contains",
        startswith: "company_name_startswith",
        endswith: "company_name_endswith",
      });

      url = appendInlineTextFilter(url, filters.program_name, {
        contains: "calque_program_contains",
        startswith: "calque_program_startswith",
        endswith: "calque_program_endswith",
      });

      url = appendNumericRangeFilter(
        url,
        filters.purchase_price,
        "purchase_price__gte",
        "purchase_price__lte",
      );

      if (filters.purchase_date) {
        const f = filters.purchase_date;
        if (f.has_date === true) {
          url += `&has_purchase_date=true`;
        } else if (f.has_date === false) {
          url += `&has_purchase_date=false`;
        }
        if (f.from && f.to) {
          url += `&existingpropertyinfo__purchase_date__range=${f.from},${f.to}`;
        }
      }

      url = appendNumericRangeFilter(
        url,
        filters.owner_estimated_value,
        "owner_estimated_home_value_gte",
        "owner_estimated_home_value_lte",
      );

      url = appendInlineTextFilter(url, filters.borrower_email, {
        contains: "borrower_email_contains",
        startswith: "borrower_email_startswith",
        endswith: "borrower_email_endswith",
      });

      url = appendInlineTextFilter(url, filters.co_borrower_name, {
        contains: "co_borrower_name_contains",
        startswith: "co_borrower_name_startswith",
        endswith: "co_borrower_name_endswith",
      });

      url = appendInlineTextFilter(url, filters.co_borrower_email, {
        contains: "co_borrower_email_contains",
        startswith: "co_borrower_email_startswith",
        endswith: "co_borrower_email_endswith",
      });

      url = appendInlineTextFilter(url, filters.loan_officer_name, {
        contains: "loan_officer_name_contains",
        startswith: "loan_officer_name_startswith",
        endswith: "loan_officer_name_endswith",
      });

      url = appendInlineTextFilter(url, filters.loan_officer_email, {
        contains: "loan_officer_email_contains",
        startswith: "loan_officer_email_startswith",
        endswith: "loan_officer_email_endswith",
      });

      url = appendInlineTextFilter(url, filters.real_estate_agent_name, {
        contains: "real_estate_agent_name_contains",
        startswith: "real_estate_agent_name_startswith",
        endswith: "real_estate_agent_name_endswith",
      });

      url = appendInlineTextFilter(url, filters.real_estate_agent_email, {
        contains: "real_estate_agent_email_contains",
        startswith: "real_estate_agent_email_startswith",
        endswith: "real_estate_agent_email_endswith",
      });

      if (filters.partner_loan_number) {
        const f = filters.partner_loan_number;
        if (f.exact) url += `&external_reference_number=${f.exact}`;
        if (f.contains) {
          url += `&external_reference_number_contains=${f.contains}`;
        }
      }

      url = appendInlineTextFilter(url, filters.initial_submiter_role, {
        contains: "submitter_role_contains",
        startswith: "submitter_role_startswith",
        endswith: "submitter_role_endswith",
      });

      url = appendInlineTextFilter(url, filters.initiail_submiter_name, {
        contains: "submitter_name_contains",
        startswith: "submitter_name_startswith",
        endswith: "submitter_name_endswith",
      });

      url = appendInlineTextFilter(url, filters.initial_submiter_email, {
        contains: "submitter_email_contains",
        startswith: "submitter_email_startswith",
        endswith: "submitter_email_endswith",
      });

      if (filters.home_owner_approved?.value !== undefined) {
        url += `&homeowner_approved=${filters.home_owner_approved.value}`;
      }

      if (
        filters.home_owner_approval_date?.from &&
        filters.home_owner_approval_date?.to
      ) {
        url += `&initialsubmitterdetail__homeowner_approved_date__range=${filters.home_owner_approval_date.from},${filters.home_owner_approval_date.to}T23:59:59`;
      }

      if (filters.is_primary_residence?.value !== undefined) {
        url += `&is_primary_residence=${filters.is_primary_residence.value}`;
      }

      url = appendNumericRangeFilter(
        url,
        filters.equity_unlock_requested,
        "equity_unlock_requested_gte",
        "equity_unlock_requested_lte",
      );
    }
    
    if (advancedFilters.submitted_to_crm !== undefined)
      url += `&submitted_to_crm=${advancedFilters.submitted_to_crm}`;

    if (advancedFilters.is_test_app !== undefined)
      url += `&is_test_app=${advancedFilters.is_test_app}`;

    if (advancedFilters.is_submitted_by_partner_api !== undefined)
      url += `&is_submitted_by_partner_api=${advancedFilters.is_submitted_by_partner_api}`;

    return url;
  };

    // Sync advanced filter selections into legacy dropdown values
  const applyAdvancedFilters = () => {
    setCxSpecialistValue(prev => {
      if (filters.cx_specialist?.length === 1) return filters.cx_specialist[0];
      if (!globalSearch) return "all";
      return prev;
    });

    setOriginatorValue(prev => {
      if (filters.originator?.length === 1) return filters.originator[0];
      if (!globalSearch) return "all";
      return prev;
    });

    setAppStatus(prev => {
      if (filters.app_status?.length === 1) return filters.app_status[0];
      if (!globalSearch) return "all";
      return prev;
    });

    setSearchTerm(globalSearch);
    setCurrentPage(1);
    setFiltersApplied(true);
  };

  const getMergedInlineFilters = () => ({
  ...pendingInlineFilters,
  ...selectedInlineFilters,
});

  //Backend export using filter-trade-in-application endpoint
  const handleExcelExport = async () => {
    let baseUrl = `${config.baseUrl}filter-trade-in-application/?export=download`;
    let url = buildAdvancedFilterUrl(baseUrl, selectedFilters, getMergedInlineFilters(),globalSearch);

    var tokenStr = localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${tokenStr}` }
      });

      if (!response.ok) {
        alert("Failed to download file");
        return;
    }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = "Applications.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (err) {
      console.error(err);
    }
  };

  const executeEmailExport = async () => {
  setIsEmailExportLoading(true);
  let baseUrl = `${config.baseUrl}filter-trade-in-application/?export=email`;
  let url = buildAdvancedFilterUrl(baseUrl, selectedFilters, getMergedInlineFilters(),globalSearch);
  var tokenStr = localStorage.getItem("access_token");
  try {
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${tokenStr}` }
    });
    const results = await response.json();
    if (response.ok) {
      setSnakbarMssg(results.message || "Exported to Email Successfully");
      setSeverityType("success");
      setOpenSnackbar(true);
    } else {
      setSnakbarMssg(results.detail || "Email export failed");
      setSeverityType("error");
      setOpenSnackbar(true);
    }
  } catch (err) {
    setSnakbarMssg("Something went wrong");
    setSeverityType("error");
    setOpenSnackbar(true);
  } finally {
    setIsEmailExportLoading(false);
  }
};

  const combinedSelectedFilters = (() => {
    const merged = {
      ...(globalSearch?.trim() && { search: globalSearch }),
      ...selectedFilters,
      ...pendingFilters,
      ...selectedInlineFilters,
      ...pendingInlineFilters,
    };
    // Preserve purchase_date Yes/No if pending date-only overwrite dropped it
    const selectedPurchase = selectedInlineFilters?.purchase_date;
    const pendingPurchase = pendingInlineFilters?.purchase_date;
    if (
      selectedPurchase?.has_date !== undefined &&
      pendingPurchase &&
      pendingPurchase.has_date === undefined
    ) {
      merged.purchase_date = {
        ...selectedPurchase,
        ...pendingPurchase,
        has_date: selectedPurchase.has_date,
      };
    }
    return merged;
  })();
//-------------------------------------------------------------------------------------

  useEffect(() => {
    localTemp = [];
    var tokenStr = localStorage.getItem('access_token')
    fetch(`${config.baseUrl}get-app-status-list/`,
        {
            headers: { "Authorization": `Bearer ${tokenStr}` }
        })
        .then(async response => {
            const results = await response.json()
            if (response.status === 201 || response.status === 200) {
                setAllStatus(results)
            } else if (response.status === 403) {
                localStorage.setItem('access_token', '')
                navigate('/');
            }
        }
        ).catch((e) => {
            console.log(e)
        });

    fetch(`${config.baseUrlCp}partner/`,
        {
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${tokenStr}`,
                'Content-Type': 'application/json'
            },
        })
        .then(async response => {
            const result = await response.json()
            if (response.status === 200 || response.status === 201) {
                setOriginatorNames(result)
            }
            else if (response.status === 403) {
                localStorage.setItem('access_token', '')
                navigate('/');
            }
        })

}, [])

  const handleClose1 = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setOpenSnackbar(false);
  };

  const handlePaginationPageClick =(page)=>{
    setCurrentPage(page)
  }

  const handleDeleteApplication =()=>{
    if (masterCheck.length !== 0) {
      setDeleteAppModal(true);
    }
  }
  const deleteAppModalClose = (event,reason) => {
    
    setDeleteAppModal(false);
  }
  const handleChatbotToggle = () => {
    setChatbotOpen(!chatbotOpen);
  };
  const handleChatbotClose = () => {
    setChatbotOpen(false);
  };

  const handleDelete = () => {
    let tokenStr = localStorage.getItem('access_token')
    fetch(`${config.baseUrl}trade-in-application/delete-application/`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${tokenStr}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ trade_in_application_id: masterCheck })
    }).then(async response => {
        const results = await response.json()
        if (response.status === 200 || response.status === 201) {
            setSnakbarMssg(results.message);
            setSeverityType("success");
            setOpenSnackbar(true);
            await sleep(1000);
            setOpenSnackbar(false);
            deleteAppModalClose();
            window.location.reload()
        }
        else {
            setSnakbarMssg(results.detail)
            setSeverityType("error");
            setOpenSnackbar(true);
            deleteAppModalClose()
            window.location.reload()
        }
    }).catch((error) => {
        console.error(error)
    })
  }
  
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function deleteApplication() {
    return (
        <>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontFamily: "proxima-semibold" }}
            >
              Are you sure you want to delete?</Typography>
              <Grid
                  container
                  spacing={2}
                  className="form-layout-btn"
                  style={{ justifyContent: "center" }}
                >
                    <Button
                        className="primary-btn"
                        variant="contained"
                        onClick={handleDelete}
                    >
                        Ok
                    </Button>
                    <Button
                        className="primary-btn-cancel"
                        variant="outlined"
                        color="primary"
                        onClick={deleteAppModalClose}
                    >
                        Cancel
                    </Button>
            </Grid>
        </>
    )
  }

  function handleApplicationCreate() {
    localStorage.setItem('isCreate',true);
    localStorage.removeItem('application_id');
    setForms();
  }

  const handleEmailExport =()=>{
    setExportModalOpen(true)
  }
  
  const exportModalClose =()=>{
    setExportModalOpen(false)
    exportDataFormik.resetForm({
      values: {
        start_date: null,
        end_date: null,
      },
    })
  }

  const initialValues = {
    start_date: null,
    end_date: null,
  }

  const validate = (values) => {
    let errors = {};
    const today = new Date();
  
    const rawStartDate = values.start_date?.trim();
    const rawEndDate = values.end_date?.trim();
  
    if (!rawStartDate && !rawEndDate) {
      errors.form = 'Please enter the mandatory fields';
      return errors;
    }
  
    if (!rawStartDate) {
      errors.form = 'Please enter the From Date';
      return errors;
    }
  
    if (!rawEndDate) {
      errors.form = 'Please enter the To Date';
      return errors;
    }
  
    const parsedStartDate = parse(rawStartDate, 'MM/dd/yyyy', new Date());
    const parsedEndDate = parse(rawEndDate, 'MM/dd/yyyy', new Date());
  
    if (!isValid(parsedStartDate)) {
      errors.form = 'From Date is invalid';
      return errors;
    }
  
    if (!isValid(parsedEndDate)) {
      errors.form = 'To Date is invalid';
      return errors;
    }
  
    if (parsedStartDate > parsedEndDate) {
      errors.form = 'From Date cannot be after To Date';
      return errors;
    }
  
    if (parsedStartDate > today) {
      errors.form = 'From date cannot be in the future';
      return errors;
    }
  
    if (parsedEndDate > today) {
      errors.form = 'To date cannot be in the future';
      return errors;
    }
  
    return errors;
  };

  const onSubmit =(values)=>{
    setIsExportLoading(true)
    const parsedStartDate = parse(values.start_date, 'MM/dd/yyyy', new Date());
    const parsedToDate = parse(values.end_date, 'MM/dd/yyyy', new Date());
      var tokenStr = localStorage.getItem('access_token')
      fetch(`${config.baseUrl}export-applications/`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${tokenStr}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          start_date:isValid(parsedStartDate) ? format(parsedStartDate, 'yyyy-MM-dd') : null,
          end_date: isValid(parsedToDate) ? format(parsedToDate, 'yyyy-MM-dd') : null,
        })
    }).then(async response => {
        if (response.status === 200 || response.status === 201) {
            const blob = await response.blob();
            const disposition = response.headers.get('Content-Disposition');
            let filename = 'export.xlsx'; // fallback default

            if (disposition) {
              const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
              if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1];
              }
            }
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            setExportModalOpen(false)
            setIsExportLoading(false)
            exportDataFormik.resetForm({
              values: {
                start_date: null,
                end_date: null,
              },
            })
        }
        else {
          const errorRes = await response.json();
          throw new Error(errorRes.detail || "Export failed");
      }
      }).catch((error) => {
        console.error(error);
        setExportModalOpen(false);
        setIsExportLoading(false);
        setSnakbarMssg(error.detail || "Something went wrong");
        setSeverityType("error");
        setOpenSnackbar(true);
        exportDataFormik.resetForm({
            values: {
              start_date: null,
              end_date: null,
            },
        });
        setTimeout(() => setOpenSnackbar(false), 1000);
    });
  }

  const exportDataFormik = useFormik({
    initialValues,
    validate,
    onSubmit,
  });

  function EmailExport() {

    const handleStartDateChange = (e) => {
      let val = e.target.value;
   
      // 1. Remove any invalid characters (allow only digits and slashes)
      val = val.replace(/[^\d/]/g, '');
     
      // 2. Count how many slashes exist
      const slashCount = (val.match(/\//g) || []).length;
     
      // 3. Prevent more than 2 slashes
      if (slashCount > 2) {
        const parts = val.split('/');
        val = parts.slice(0, 3).join('/');
      }
     
      // 4. Automatically add slashes while typing only if not already there
      const digitsOnly = val.replace(/\D/g, '');
      if (!val.includes('/') && digitsOnly.length > 2) {
        val =  `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`;
      }
      if ((val.match(/\//g) || []).length === 1 && digitsOnly.length > 4) {
        val = `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2, 4)}/${digitsOnly.slice(4, 8)}`;
      }
     
      // 5. Limit to 10 characters max (MM/DD/YYYY)
      if (val.length > 10) {
        val = val.slice(0, 10);
      }
     
      exportDataFormik.setFieldValue('start_date', val);
     
      // 6. Validate if full date is present
      if (val.length === 10) {
        const [mmStr, ddStr, yyyyStr] = val.split('/');
        const mm = Number(mmStr);
        const dd = Number(ddStr);
        const yyyy = Number(yyyyStr);
     
        const today = new Date();
        const maxYear = today.getFullYear();
        const parsed = new Date(yyyy, mm - 1, dd);
        setSelectedStartDate(parsed);
      } else {
        setSelectedStartDate(null);
      }
    };

    const handleEndDateChange = (e) => {
      let val = e.target.value;
   
      // 1. Remove any invalid characters (allow only digits and slashes)
      val = val.replace(/[^\d/]/g, '');
     
      // 2. Count how many slashes exist
      const slashCount = (val.match(/\//g) || []).length;
     
      // 3. Prevent more than 2 slashes
      if (slashCount > 2) {
        const parts = val.split('/');
        val = parts.slice(0, 3).join('/');
      }
     
      // 4. Automatically add slashes while typing only if not already there
      const digitsOnly = val.replace(/\D/g, '');
      if (!val.includes('/') && digitsOnly.length > 2) {
        val =  `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`;
      }
      if ((val.match(/\//g) || []).length === 1 && digitsOnly.length > 4) {
        val = `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2, 4)}/${digitsOnly.slice(4, 8)}`;
      }
     
      // 5. Limit to 10 characters max (MM/DD/YYYY)
      if (val.length > 10) {
        val = val.slice(0, 10);
      }
     
      exportDataFormik.setFieldValue('end_date', val);
     
      // 6. Validate if full date is present
      if (val.length === 10) {
        const [mmStr, ddStr, yyyyStr] = val.split('/');
        const mm = Number(mmStr);
        const dd = Number(ddStr);
        const yyyy = Number(yyyyStr);
     
        const today = new Date();
        const maxYear = today.getFullYear();
     
        const parsed = new Date(yyyy, mm - 1, dd);
        setSelectedEndDate(parsed);
      } else {
        // Partial input, clear error
        setSelectedEndDate(null);
      }
    };

    const handleStartDateCalendarChange = (date) => {
      if (date && date <= new Date()) {
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        const formatted = `${mm}/${dd}/${yyyy}`;
        exportDataFormik.setFieldValue('start_date', formatted);
      }
    };
    const handleEndDateCalendarChange = (date) => {
      if (date && date <= new Date()) {
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const yyyy = date.getFullYear();
        const formatted = `${mm}/${dd}/${yyyy}`;
        exportDataFormik.setFieldValue('end_date', formatted);
      }
    };

    return (
      <>
        <form onSubmit={exportDataFormik.handleSubmit}>
          <Grid
            container
            sx={{
              display: "flex",
              justifyContent: "center",
              maxWidth: "650px",
            }}
            rowGap={3}
          >
            <Grid
              item
              size={{ md: 5, lg: 5 }}
              sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <label
                style={{ fontSize: "14px", fontFamily: "proxima-semibold" }}
              >
                From Date <span className="asterisk">*</span>
              </label>
               <CustomDateInput
                   value={exportDataFormik.values.start_date}
                   name='start_date'
                   handleInputChange={handleStartDateChange}
                   handleCalendarChange={handleStartDateCalendarChange}
                   ref={startDatePickerRef}
                   selectedDate={selectedStartDate}
                  />
            </Grid>
            <Grid
              item
              size={{ md: 5, lg: 5 }}
              sx={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              <label
                style={{ fontSize: "14px", fontFamily: "proxima-semibold" }}
              >
                To Date <span className="asterisk">*</span>
              </label>
               <CustomDateInput
                   value={exportDataFormik.values.end_date}
                   name='end_date'
                   handleInputChange={handleEndDateChange}
                   handleCalendarChange={handleEndDateCalendarChange}
                   ref={endDatePickerRef}
                   selectedDate={selectedEndDate}
                  />
            </Grid>
            {exportDataFormik.submitCount > 0 && exportDataFormik?.errors?.form ? (
              <div className="section-error" style={{ width: "60%" }}>
                {exportDataFormik?.errors?.form}
              </div>
            ) : (
              ""
            )}
            <Grid
              item
              size={{ md: 6, lg: 6 }}
              sx={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <Button
                className="app-primary-btn"
                variant="contained"
                type="submit"
                disabled={isExportLoading}
              >
                {isExportLoading === false ? (
                  "Submit"
                ) : (
                  <CircularProgress
                    className="circular_spiner"
                    size={24}
                    sx={{ color: "white" }}
                  />
                )}
              </Button>
              <Button
                className="primary-btn-cancel"
                variant="outlined"
                color="primary"
                onClick={exportModalClose}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </form>
      </>
    );
  }
  
  // ── Props passed down to ApplicationListingTable
  const showSnackbarMessage = (message, severity = "success") => {
    setSnakbarMssg(message);
    setSeverityType(severity);
    setOpenSnackbar(true);
  };

  const applicationListingTableProps = {
    searchTerm,
    cxSpecialistValue,
    originatorValue,
    appStatus,
    currentPage,
    masterCheck,
    setMasterCheck,
    handlePaginationPageClick,
    // Advanced filters
    advancedFilters: selectedFilters,
    buildAdvancedFilterUrl,
    // Inline filters
    pendingInlineFilters,
    setPendingInlineFilters,
    selectedInlineFilters,
    setSelectedInlineFilters,
    setTableData,
    pageSize,
    setPageSize,
    filterApplyCount,
    showSnackbarMessage,
  };

  // props passed for advancefilter
  const advanceFilterProps ={
    showFilters,
    pendingFilters,
    setPendingFilters,
    globalSearch,
    setGlobalSearch,
    inputText,
    setInputText,
    updatePendingFilter,
    applyFilters,
    clearAllFilters,
    cxSpecialists,
    originators:originatorNames,
    statuses:allStatus,
    tableData,
    masterCheck,
    onDeleteSelected:handleDeleteApplication,
    dateError,
    setDateError,
    states,
    handleExcelExport,
    executeEmailExport,
    setFiltersAppliedOnce,
    filtersAppliedOnce,
    setSelectedFilters
  }

  return (
    <>
      <div className="application-listing-container">
        <div className="application-lisiting-head-btn-container ">
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Button
            className="app-primary-btn"
              sx={{
                backgroundColor: showFilters ? '#4da3f5' : '#067de2',
                color: 'white',
              }}
              onClick={() => setShowFilters(!showFilters)}
            >
              {showFilters ? (
                    <FilterAltOffIcon sx={{ fontSize: 20 }} />
              ) : (
                    <FilterAltIcon sx={{ fontSize: 20 }} />
              )}
              <span style={{ marginTop: '2px' }}>
                {showFilters ? 'Hide Filters' : 'Show Filters'}
              </span>
            </Button>
          </div>
          <div>
            <NavLink
              style={{ textDecoration: "none", color: "white" }}
              exact
              to="/application-create"
            >
              <Button
                className="app-primary-btn"
                sx={{ color: "#fff", background: "#067de2",
                  '& .MuiButton-startIcon':{
                    margin:'1px 3px 0px -2px'
                  }
                }}
                onClick={handleApplicationCreate}
                startIcon={<EditOutlinedIcon style={{ color: "#fff",marginBottom:'3px',fontSize: "18px" }}/>}
              >
                Create Application
              </Button>
            </NavLink>
          </div>
          <div>
            <Button
              className="app-primary-btn"
              sx={{
                backgroundColor: masterCheck.length === 0 ? "#EBEBE4" : "#067de2",
                color: masterCheck.length !== 0 ? "#fff" : "",
                border: masterCheck.length === 0 ? "1px solid #EBEBE4" : "",
                '& .MuiButton-startIcon':{
                    margin:'0px 0px 2px 0px'
                  }
              }}
              onClick={handleDeleteApplication}
              disabled={masterCheck.length === 0}
              startIcon={<DeleteIcon
                style={{ color: "#fff",fontSize: "16px" }}
              />}
            >
              
              Delete
            </Button>
          </div>
          <div>
              <Button
                className="app-primary-btn"
                sx={{ color: "#fff", background: "#067de2",
                  '& .MuiButton-startIcon':{
                    margin:'0px 3px 0px -2px'
                  }
                }}
                onClick={handleEmailExport}
                startIcon={
                  <svg width="20" height="20" viewBox="0 0 25 28" xmlns="http://www.w3.org/2000/svg">
                    <path 
                      d="M3 23h18V6.709L15.29 1H3zM15 2h.2L20 6.8V7h-5zM4 2h10v6h6v14H4zm11.891 8l-3.273 4.5 3.273 4.5h-1.236L12 15.35 9.345 19H8.11l3.273-4.5L8.109 10h1.236L12 13.65 14.655 10z" 
                      stroke="#fff" 
                      stroke-width="1.1" 
                      fill="none"
                    />
                    <path fill="none" d="M0 0h24v24H0z"/>
                  </svg>
                  }
              >
                Export
              </Button>
          </div>
        </div>
        <AdvancedFilterPanel props = {advanceFilterProps}/>
        {/* Active filter tags*/}
        {Object.entries(combinedSelectedFilters)
          .filter(([key, value]) => {
            if (value === undefined || value === null || value === "") return false;
            if (Array.isArray(value) && value.length === 0) return false;
            if (typeof value === "object" && !Array.isArray(value)) {
              if (value.value !== undefined) return true;
              if (value.is_null !== undefined) return true;
              if (value.from !== undefined || value.to !== undefined || value.on !== undefined || value.has_date !== undefined) return true;
              if (
                !value.contains &&
                !value.startswith &&
                !value.endswith &&
                !value.zip_code &&
                !value.exact &&
                !value.gte &&
                !value.lte
              )
                return false;
            }
            return true;
          }).length > 0 && (
          <div
            style={{
              background: "#f9f9f9",
              padding: "10px 15px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              margin: "15px 0px 0px",
              display: "flex",
              flexWrap: "wrap",
              gap: "8px"
            }}
          >
            {Object.entries(combinedSelectedFilters)
              .filter(([key, value]) => {
                if (value === undefined || value === null || value === "") return false;
                if (Array.isArray(value) && value.length === 0) return false;
                if (typeof value === "object" && !Array.isArray(value)) {
                  if (value.value !== undefined) return true;
                  if (value.is_null !== undefined) return true;
                  if (value.from !== undefined || value.to !== undefined || value.on !== undefined || value.has_date !== undefined) return true;
                  if (
                    !value.contains &&
                    !value.startswith &&
                    !value.endswith &&
                    !value.zip_code &&
                    !value.exact &&
                    !value.gte &&
                    !value.lte
                  )
                    return false;
                }
                return true;
              })
              .map(([key, value]) => {
                const displayNames = {
                  created_date_range_label: "Created Date",
                  created_date: "Created Date",
                  created_date_on: "Created On",
                  updated_date: "Updated Date",
                  cx_specialist: "CX Specialist",
                  app_status: "Status",
                  originator: "Originator",
                  property_types: "Property Type",
                  state: "State",
                  submitted_to_crm: "Submitted to CRM",
                  is_submitted_by_partner_api: "Submitted by Partner API",
                  is_upside_submission: "Is Upside Submission",
                  is_upside_interested:"Is Upside Interested",
                  is_test_app: "Test Application",
                  borrower_name: "Borrower Name",
                  property_address: "Property Address",
                  cx_specialist_name: "CX Specialist",
                  application_status_name: "Status",
                  search: "Search",
                  originator_name: "Originator Name",
                  application_number: "Trade In Application Number",
                  property_type: "Property Type",
                  company_name: "Company Name",
                  program_name: "Program Name",
                  purchase_price: "Purchase Price",
                  purchase_date: "Purchase Date",
                  owner_estimated_value: "Owner Estimated Value",
                  borrower_email: "Borrower Email",
                  co_borrower_name: "Co-Borrower Name",
                  co_borrower_email: "Co-Borrower Email",
                  loan_officer_name: "Loan Officer Name",
                  loan_officer_email: "Loan Officer Email",
                  real_estate_agent_name: "Real Estate Agent Name",
                  real_estate_agent_email: "Real Estate Agent Email",
                  partner_loan_number: "Partner Loan Number",
                  initial_submiter_role: "Initial Submitter Role",
                  initiail_submiter_name: "Initial Submitter Name",
                  initial_submiter_email: "Initial Submitter Email",
                  home_owner_approved: "Homeowner Approved",
                  home_owner_approval_date: "Homeowner Approval Date",
                  is_primary_residence: "Is Primary Residence",
                  equity_unlock_requested: "Equity Unlock Requested",
                };

                const tagStyle = {
                  display: "inline-flex",
                  alignItems: "stretch",
                  backgroundColor: "#e3f2ff",
                  color: "#067de2",
                  border: "2px solid #067de2",
                  borderRadius: "5px",
                  fontSize: "14px",
                  fontWeight: "600",
                  overflow: "hidden",
                };

                const labelStyle = {
                  padding: "10px",
                };

                const btnStyle = {
                  background: "#fff",
                  border: "none",
                  borderLeft: "2px solid #067de2",
                  color: "#067de2",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "700",
                  padding: "0 12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                };

                const removeFilterTag = (removeKey) => {
                  if (removeKey === "search") {
                    setGlobalSearch("");
                    setSearchTerm("");
                    return;
                  }
                  setSelectedInlineFilters(prev => {
                    const copy = { ...prev };
                    delete copy[removeKey];
                    return copy;
                  });
                  setPendingFilters(prev => {
                    const copy = { ...prev };
                    delete copy[removeKey];
                    return copy;
                  });
                  setSelectedFilters(prev => {
                    const copy = { ...prev };
                    delete copy[removeKey];
                    return copy;
                  });
                  setPendingInlineFilters((prev) => {
                    const copy = { ...prev };
                    delete copy[removeKey];
                    return copy;
                  });
                  
                };
                
                if (
                  typeof value === "object" &&
                  !Array.isArray(value) &&
                  value.value !== undefined
                ) {
                  const labelValue = value.value ? "Yes" : "No";
                  return (
                    <span key={key} style={tagStyle}>
                      <span style={labelStyle}>
                        {displayNames[key] || key} : {labelValue}
                      </span>
                      <button
                        onClick={() => removeFilterTag(key)}
                        style={btnStyle}
                      >
                        ✕
                      </button>
                    </span>
                  );
                }

              if (
                  typeof value === "object" &&
                  !Array.isArray(value) &&
                  value.is_null !== undefined
                ) {
                  return (
                    <span key={key} style={tagStyle}>
                      <span style={labelStyle}>
                        {displayNames[key] || key} : Not Available
                      </span>
                      <button onClick={() => removeFilterTag(key)} style={btnStyle}>✕</button>
                    </span>
                  );
                }  

              if (
                typeof value === "object" &&
                !Array.isArray(value) &&
                (value.from !== undefined ||
                  value.to !== undefined ||
                  value.on !== undefined ||
                  value.has_date !== undefined)
              ) {
                const fmt = (iso) => {
                  if (!iso) return "";
                  if (iso.includes("/")) return iso;
                  const [y, m, d] = iso.split("-");
                  if (!y || !m || !d) return iso;
                  return `${m}/${d}/${y}`;
                };
                if (key === "updated_date") {
                  return (
                    <span key={key} style={tagStyle}>
                      <span style={labelStyle}>
                        Updated Date On : {fmt(value.on)}
                      </span>
                      <button onClick={() => removeFilterTag(key)} style={btnStyle}>
                        ✕
                      </button>
                    </span>
                  );
                }

                const rangeBaseLabel = displayNames[key] || key;
                const parts = [];
                if (value.has_date !== undefined) {
                  parts.push(value.has_date ? "Yes" : "No");
                }
                if (value.on) {
                  parts.push(`On ${fmt(value.on)}`);
                } else if (value.from && value.to) {
                  parts.push(`${fmt(value.from)} – ${fmt(value.to)}`);
                } else if (value.from) {
                  parts.push(`From ${fmt(value.from)}`);
                } else if (value.to) {
                  parts.push(`To ${fmt(value.to)}`);
                }
                return (
                  <span key={key} style={tagStyle}>
                    <span style={labelStyle}>
                      {rangeBaseLabel} : {parts.join(", ")}
                    </span>
                    <button onClick={() => removeFilterTag(key)} style={btnStyle}>
                      ✕
                    </button>
                  </span>
                );
              }

                // Inline filter object (contains / startswith / endswith / zip / exact / gte / lte)
                if (typeof value === "object" && !Array.isArray(value)) {
                  const parts = [];
                  if (value.exact) parts.push(`exact "${value.exact}"`);
                  if (value.contains) parts.push(`contains "${value.contains}"`);
                  if (value.startswith) parts.push(`starts with "${value.startswith}"`);
                  if (value.endswith) parts.push(`ends with "${value.endswith}"`);
                  if (value.zip_code) parts.push(`zip ${value.zip_code}`);
                  if (value.gte) parts.push(`≥ ${value.gte}`);
                  if (value.lte) parts.push(`≤ ${value.lte}`);

                  if (parts.length === 0) return null;

                  return (
                    <span key={key} style={tagStyle}>
                      <span style={labelStyle}>
                        {displayNames[key] || key} : {parts.join(", ")}
                      </span>
                      <button onClick={() => removeFilterTag(key)} style={btnStyle}>✕</button>
                    </span>
                  );
                }
                  
                // Boolean fields
                let labelValue = value;
                if (key === "is_test_app" || key === "submitted_to_crm") {
                  labelValue = value ? "Yes" : "No";
                }
                if (
                  key === "is_test_app" ||
                  key === "submitted_to_crm" ||
                  key === "is_submitted_by_partner_api"
                ) {
                  const raw =
                    typeof value === "object" && value !== null
                      ? value.value
                      : value;
                  labelValue = raw ? "Yes" : "No";
                }

                if (key === "created_date_from" || key === "created_date_to" || key === "created_date_on") {
                    const [y, m, d] = value.split("-");
                    labelValue = `${m}/${d}/${y}`;
                }

                // State mapping
                if (key === "state" && Array.isArray(value)) {
                  labelValue = value
                    .map(id => {
                      const st = states?.find(s => s.state_id === id);
                      return st ? st.state_name : id;
                    })
                    .join(", ");
                }

                // Property Type mapping
                if (key === "property_types" && Array.isArray(value)) {
                  labelValue = value
                    .map(id => {
                      const pt = PROPERTY_TYPE_OPTIONS.find(p => p.id === id);
                      return pt ? pt.label : id;
                    })
                    .join(", ");
                }

                // Status mapping
                if (key === "app_status" && Array.isArray(value)) {
                  labelValue = value
                    .map(id => {
                      const st = allStatus?.find(s => s.application_status_id === id);
                      return st ? st.application_status : id;
                    })
                    .join(", ");
                }

                // CX Specialist mapping
                if (key === "cx_specialist") {
                  labelValue = value
                    .map(id => {
                      const s = cxSpecialists?.find(c => c.id === id);
                      return s ? s.get_user_full_name : id;
                    })
                    .join(", ");
                }

                // Originator mapping
                if (key === "originator") {
                  labelValue = value
                    .map(id => {
                      const o = originatorNames?.find(x => x.partner_id === id);
                      return o ? o.partner_name : id;
                    })
                    .join(", ");
                }

                return (
                  <span key={key} style={tagStyle}>
                    <span style={labelStyle}>
                      {displayNames[key] || key} : {labelValue}
                    </span>
                    <button onClick={() => removeFilterTag(key)} style={btnStyle}>✕</button>
                  </span>
                );
              })}

            {/* Clear All */}
            <button
              onClick={() => {
                setSelectedInlineFilters({});
                setPendingInlineFilters({});
                setSelectedFilters({});
                setPendingFilters({});
                setDateError(null);
                setFilterApplyCount(0);
                clearAllFilters();
              }}
              style={{
                backgroundColor: "#1976d2",
                color: "white",
                border: "none",
                borderRadius: "5px",
                padding: "10px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Clear All
            </button>
          </div>
        )}

        <Grid container>
          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
            <ApplicationListingTable props={applicationListingTableProps} />
          </Grid>
        </Grid>
      </div>
      {/* Existing Modals */}
      <CustomModal
        open={deleteAppModalOpen}
        header={"Delete Applications"}
        body={deleteApplication()}
        handleClose={deleteAppModalClose}
      />
      <CustomModal
        open={exportModalOpen}
        header={"Select Dates For Export"}
        body={EmailExport()}
        handleClose={exportModalClose}
      />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose1}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose1} severity={severityType} elevation={6} variant="filled">
          <div className="error" style={{ color: 'white' }}>
            <span>{snakbarMssg}</span>
          </div>
        </Alert>
      </Snackbar>

      {/* NEW: Backdrop for click outside */}
      <Backdrop
        open={chatbotOpen}
        sx={{
          backgroundColor: 'transparent',
          zIndex: 1299
        }}
        onClick={handleChatbotClose}
      />

      {/* NEW: AI Chatbot Component */}
      <AIChatbot
        open={chatbotOpen}
        onClose={handleChatbotClose}
      />

      {/* NEW: Floating Chat Button */}
      <Fab
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          backgroundColor: '#067de2',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#0056b3'
          },
          zIndex: 1000
        }}
        onClick={handleChatbotToggle}
      >
        <ChatIcon />
      </Fab>
    </>
  );
}

export default Layout(ApplicationListing);